import {
    useArgumentsQuery as _useArgumentsQuery,
    useAppMode,
    useSelectedComment,
    useSelectedCommentDecisionQuery,
    useTicket,
} from '@tymely/services';
import sortBy from 'lodash/sortBy';
import React from 'react';
import { useAtomValue } from 'jotai';
import { selectedPolicySetIdAtom } from '@tymely/atoms/policySet.atoms';

const useArgumentsQuery = ({ version }: { version?: string }) => {
    const comment = useSelectedComment();
    const { isQaMode } = useAppMode();
    const ticket = useTicket();
    const { data: decision } = useSelectedCommentDecisionQuery();

    const selectedPolicySetId = useAtomValue(selectedPolicySetIdAtom);
    const asSeenAtComment = React.useMemo(() => {
        if (version) {
            return version;
        }
        if (comment && isQaMode) {
            const srotedComments = sortBy(ticket.comments, 'created_date');
            const foundComment = srotedComments.find(
                ({ is_customer, created_date }) => is_customer && created_date > comment.created_date,
            );
            return foundComment?.created_date;
        }
        return decision?.created_date;
    }, [version, ticket, comment, selectedPolicySetId, decision]);

    return _useArgumentsQuery({
        commentId: comment?.id,
        argsVersion: asSeenAtComment,
        enabled: !!comment?.selected_intent_id,
        ...(selectedPolicySetId ? { policySetId: selectedPolicySetId } : {}),
    });
};

export default useArgumentsQuery;
